import React from 'react';

interface Props {
  children: React.ReactNode;
  onClick: () => void;
  leftSection?: React.ReactNode;
}
function SecondaryButton({
  children,
  onClick,
  leftSection,
}: Props): JSX.Element {
  return (
    <div
      className="flex items-center justify-center cursor-pointer gap-[10px] h-full"
      onClick={onClick}>
      {leftSection}
      <span className="text-[16px] font-medium">{children}</span>
    </div>
  );
}

export default SecondaryButton;
